import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/organizations/$organizationId/builder/$docbuilderSlug/')({
  beforeLoad: ({ params }) => {
    // Redirect to build format by default
    throw redirect({
      to: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format',
      params: {
        organizationId: params.organizationId,
        docbuilderSlug: params.docbuilderSlug,
        format: 'build',
      },
    })
  },
})
